import React from 'react';

const ContactButtons = () => {
  return (
    <div 
      className="contact-buttons" 
      style={{
        position: 'fixed', 
        bottom: '20px', 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'space-between', 
        padding: '0 20px', 
        zIndex: 1000,
        pointerEvents: 'none', 
      }}
    >
      
      <a 
        href="tel:+917620911746" 
        className="call-button" 
        style={{
          backgroundColor: '#F8911B', 
        
          borderRadius: '50%',
          border : '1px solid white',
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001, // Ensure button is above the container
          pointerEvents: 'auto', // Allow clicks on this specific button
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#F8911B')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#F8911B')}
      >
        <img src="./images/call.webp" alt="Call" style={{ width: '30px', height: '30px' }} />
      </a>

      <a 
        href="https://wa.me/+917620911746?text=Hello%20Skyline%20Cabs%20Team%2C%0A%0AI%E2%80%99m%20planning%20a%20trip%20and%20would%20like%20to%20inquire%20about%20your%20cab%20and%20taxi%20services.%20Could%20you%20please%20share%20the%20available%20options%20along%20with%20the%20fare%20details%3F%20I%20appreciate%20your%20assistance%20and%20look%20forward%20to%20your%20response.%20Thank%20you%21!"


        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#25D366', 
          borderRadius: '50%', 
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001,
          pointerEvents: 'auto', 
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1DAE3E')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#25D366')}
      >
        <img src="./images/whatsapp.webp" alt="WhatsApp" style={{ width: '30px', height: '30px' }} />
      </a>

    </div>
  );
};

export default ContactButtons;

